import React, { useEffect, useRef, useState } from 'react';
import PropTypes from 'prop-types';

import { RideGlLeft, RideGlRight, RideGrid } from '@rimac-seguros/ride-system-components';
import Slider from 'react-slick';

import PlanItem from '../../../components/molecules/plan-item-simple';
import { useAppContext } from '../../../AppProvider';

import './styles.scss';

const RbrFlexiblePlans = ({ authoring }) => {
  const { title, subTitle, plans } = authoring;
  const [activeSlide, setActiveSlide] = useState(1);
  const { state: { experiments } } = useAppContext();

  const slider = useRef();

  useEffect(() => {
    if (plans.some((plan) => plan.isRecommend)) {
      setActiveSlide(plans.findIndex((plan) => plan.isRecommend) + 1);
    }
  }, [plans]);

  const previous = () => {
    slider.current.slickPrev();
  };

  const next = () => {
    slider.current.slickNext();
  };

  const getActiveSlide = () => plans.findIndex((plan) => plan.isRecommend) ?? 0;

  return (
    <RideGrid className="section-plans">
      <div className="section-plans__head">
        <h2 dangerouslySetInnerHTML={{ __html: title }} />
        <p dangerouslySetInnerHTML={{ __html: subTitle }} />
      </div>
      {/* Plan Mobile */}
      <div className="section-plans__content-mobile">
        <div>
          <Slider
            ref={slider}
            variableWidth
            swipeToSlide
            slidesToShow={1}
            infinite
            speed={500}
            centerMode
            initialSlide={getActiveSlide()}
            beforeChange={(current, nxt) => {
              setActiveSlide(nxt + 1);
            }}
          >
            {plans.map((_) => (
              <PlanItem key={`plan-${_.id}`} plan={_} experiment={experiments.newPrice} />
            ))}
          </Slider>
        </div>
        <div className="slider-arrows">
          <div className="slider-arrow" onClick={previous}>
            <RideGlLeft size="large" />
          </div>
          <div className="slider-counter">{`${activeSlide} / ${plans.length}`}</div>
          <div className="slider-arrow" onClick={next}>
            <RideGlRight size="large" />
          </div>
        </div>
      </div>
      {/* Plan Desktop */}
      {plans.map((_) => (
        <PlanItem key={`plan-${_.id}`} plan={_} className="section-plans__content-desktop" experiment={experiments.newPrice} />
      ))}
    </RideGrid>
  );
};

RbrFlexiblePlans.propTypes = {
  authoring: PropTypes.shape({
    title: PropTypes.string.isRequired,
    subTitle: PropTypes.string.isRequired,
    plans: PropTypes.arrayOf(
      PropTypes.shape({
        id: PropTypes.number.isRequired,
        name: PropTypes.string.isRequired,
        price: PropTypes.number.isRequired,
        currency: PropTypes.string.isRequired,
        period: PropTypes.string.isRequired,
        isRecommend: PropTypes.bool.isRequired,
        coverages: PropTypes.arrayOf(
          PropTypes.shape({
            icon: PropTypes.string.isRequired,
            description: PropTypes.string.isRequired,
          }),
        ).isRequired,
      }),
    ).isRequired,
  }).isRequired,
};

export default RbrFlexiblePlans;
